import { render, staticRenderFns } from "./LibraryFolderDatasetPermissions.vue?vue&type=template&id=688a266e&"
import script from "./LibraryFolderDatasetPermissions.vue?vue&type=script&lang=js&"
export * from "./LibraryFolderDatasetPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports